export const mlbOffStats = {
    "batting.AB": "at bats",
    "batting.R": "runs scored",
    "batting.H": "hits",
    "batting.HR": "home runs",
    "batting.RBI": "RBIs",
    "batting.BB": "walks taken",
    "batting.HBP": "batters hit by pitch",
    "batting.SO": "strike outs",
    "batting.PA": "plate appearances",
    "batting.BA": "batting average",
    "batting.OBP": "on base percentage",
    "batting.SLG": "slugging percentage",
    "batting.OPS": "OPS",
    "batting.Pit": "pitches taken",
    "batting.Str": "strikes taken",
    "batting.singles": "singles",
    "batting.doubles": "doubles",
    "batting.triples": "triples",
    "batting.SF": "sac flies",
    "batting.SB": "stolen bases",
    "batting.CS": "runners caught stealing",
    "batting.LOB": "runners left on base"
};

export const mlbOffStatVerbs = {
    "batting.AB": "are",
    "batting.R": "are",
    "batting.H": "are",
    "batting.HR": "are",
    "batting.RBI": "are",
    "batting.BB": "are",
    "batting.HBP": "are",
    "batting.SO": "are",
    "batting.PA": "are",
    "batting.BA": "is",
    "batting.OBP": "is",
    "batting.SLG": "is",
    "batting.OPS": "is",
    "batting.Pit": "are",
    "batting.Str": "are",
    "batting.singles": "are",
    "batting.doubles": "are",
    "batting.triples": "are",
    "batting.SF": "are",
    "batting.SB": "are",
    "batting.CS": "are",
    "batting.LOB": "are"
};

export const mlbDefStats = {
    "pitching.IP": "innings pitched",
    "pitching.H": "hits given up",
    "pitching.R": "runs given up",
    "pitching.ER": "earned runs",
    "pitching.BB": "batters walked",
    "pitching.SO": "strike outs thrown",
    "pitching.HR": "home runs given up",
    "pitching.ERA": "ERA",
    "pitching.BF": "batters faced",
    "pitching.Pit": "pitches thrown",
    "pitching.Str": "strikes thrown"
};

export const mlbDefStatVerbs = {
    "pitching.IP": "are",
    "pitching.H": "are",
    "pitching.R": "are",
    "pitching.ER": "are",
    "pitching.BB": "are",
    "pitching.SO": "are",
    "pitching.HR": "are",
    "pitching.ERA": "is",
    "pitching.BF": "are",
    "pitching.Pit": "are",
    "pitching.Str": "are"
};

export const mlbTeams = {
    "ARI": "Diamondbacks",
    "ATL": "Braves",
    "BAL": "Orioles",
    "BOS": "Redsox",
    "CHC": "Cubs",
    "CHW": "Whitesox",
    "CIN": "Reds",
    "CLE": "Guardians",
    "COL": "Rockies",
    "DET": "Tigers",
    "HOU": "Astros",
    "KC": "Royals",
    "LAA": "Angels",
    "LAD": "Dodgers",
    "MIA": "Marlins",
    "MIL": "Brewers",
    "MIN": "Twins",
    "NYM": "Mets",
    "NYY": "Yankees",
    "ATH": "Athletics",
    "PHI": "Phillies",
    "PIT": "Pirates",
    "SD": "Padres",
    "SEA": "Mariners",
    "SF": "Giants",
    "STL": "Cardinals",
    "TB": "Rays",
    "TEX": "Rangers",
    "TOR": "Blue Jays",
    "WSH": "Nationals",
};

export const mlbTeamIds = {
    "ARI": 14,
    "ATL": 26,
    "BAL": 19,
    "BOS": 25,
    "CHC": 9,
    "CHW": 16,
    "CIN": 2,
    "CLE": 10,
    "COL": 23,
    "DET": 17,
    "HOU": 30,
    "KC": 5,
    "LAA": 21,
    "LAD": 1,
    "MIA": 22,
    "MIL": 32,
    "MIN": 20,
    "NYM": 18,
    "NYY": 29,
    "ATH": 24,
    "PHI": 12,
    "PIT": 4,
    "SD": 33,
    "SEA": 13,
    "SF": 15,
    "STL": 31,
    "TB": 11,
    "TEX": 28,
    "TOR": 3,
    "WSH": 35
}

export const mlbLeagues = {
    "NL": {
        "East": ["ATL", "MIA", "NYM", "PHI", "WSN"],
        "Central": ["CHC", "CIN", "MIL", "PIT", "STL"],
        "West": ["ARI", "COL", "LAD", "SDP", "SFG"]
    },
    "AL": {
        "East":["BAL", "BOS", "NYY", "TBR", "TOR"],
        "Central":["CHW", "CLE", "DET", "KCR", "MIN"],
        "West":["HOU", "LAA", "OAK", "SEA", "TEX"]
    }
};

export const mlbHigherIsBetter = {
    "batting.AB": true,
    "batting.R": true,
    "batting.H": true,
    "batting.HR": true,
    "batting.RBI": true,
    "batting.BB": true,
    "batting.HBP": true,
    "batting.SO": false,
    "batting.PA": true,
    "batting.BA": true,
    "batting.OBP": true,
    "batting.SLG": true,
    "batting.OPS": true,
    "batting.Pit": true,
    "batting.Str": false,
    "batting.singles": true,
    "batting.doubles": true,
    "batting.triples": true,
    "batting.SF": true,
    "batting.SB": true,
    "batting.CS": false,
    "batting.LOB": false,
    "pitching.IP": false,
    "pitching.H": false,
    "pitching.R": false,
    "pitching.ER": false,
    "pitching.BB": false,
    "pitching.SO": true,
    "pitching.HR": false,
    "pitching.ERA": false,
    "pitching.BF": false,
    "pitching.Pit": false,
    "pitching.Str": true
};